const Errors = {
  SERVER_ERROR:
    "Ocurrió un error en la petición, por favor intenta nuevamente.",
};

const EmployeeStatus = {
  ACTIVE: { key: 1, label: "ACTIVO", color: "badge-green" },
  INACTIVE: { key: 2, label: "SIN CONTRATO", color: "badge-gray" },
};

const IdentifierType = {
  DNI: { key: 1, label: "D.N.I." },
  CE: { key: 4, label: "CARNE DE EXTRANJERIA" },
  PASAPORTE: { key: 7, label: "PASAPORTE" },
  CARNE_REFUGIO: { key: 9, label: "CARNE DE SOLICITUD DE REFUGIO" },
  CARNE_IDENTIDAD: { key: 22, label: "CARNE DE IDENTIDAD – RR.EE." },
  CARNE_PERMANENCIA: { key: 23, label: "CARNE PERMISO TEMP. PERMANENCIA" },
  DNI_EXTRANJERO: { key: 24, label: "DOC. DE IDENTIDAD EXTRANJERO" },
  LIBRETA_MILITAR: { key: 90, label: "LIBRETA MILITAR" },
  CARNET_MILITAR: { key: 91, label: "CARNET MILITAR" },
  OTROS: { key: 0, label: "OTROS" },
};

const BooleanTypes = {
  YES: { key: 1, label: "SÍ" },
  NO: { key: 0, label: "NO" },
}

const AreaStatus = {
  ACTIVE: { key: 1, label: "ACTIVO", color: "badge-green", action: 'Suspender' },
  INACTIVE: { key: 2, label: "SUSPENDIDO", color: "badge-yellow", action: 'Activar' },
}

const CompanyStatus = {
  ACTIVE: { key: 1, label: "ACTIVO", color: "badge-green", action: 'Suspender' },
  INACTIVE: { key: 2, label: "SUSPENDIDO", color: "badge-yellow", action: 'Activar' },
}

const ContractDurationOptions = {
  ONE_MONTH: { key: 1, label: "1 mes" },
  THREE_MONTHS: { key: 2, label: "3 meses" },
  SIX_MONTHS: { key: 3, label: "6 meses" },
  ONE_YEAR: { key: 4, label: "1 año" },
  INDEFINITE: { key: 5, label: "Indeterminado" },
  POR_SERVICIO: { key: 6, label: "Por servicio" },
  PYME: { key: 7, label: "PYME" },
}

const RolesStatus = {
  ACTIVE: { key: 1, label: "ACTIVO", color: "badge-green", action: 'Suspender' },
  INACTIVE: { key: 2, label: "SUSPENDIDO", color: "badge-yellow", action: 'Activar' }
}

const ContractStatus = {
  ACTIVE:  { key: 1, label: "VIGENTE", color: "badge-green",     action: 'Cesar' },
  EXPIRED: { key: 2, label: "VENCIDO", color: "badge-warning",   action: 'Renovar' },
  CEASED:  { key: 3, label: "CESADO",  color: "badge-secondary", action: '' },
}

const TerminationReason = {
  RENUNCIA:      { key: 'RENUNCIA',      label: 'Renuncia' },
  DESPIDO:       { key: 'DESPIDO',       label: 'Despido' },
  NO_RENOVACION: { key: 'NO_RENOVACION', label: 'No renovación' },
}

const PayrollTypes = {
  OPERATORS: { key: 1, label: "OPERADORES" },
  ADMINISTRATORS: { key: 2, label: "ADMINISTRATIVOS" }
}

const AccountType = {
  SAVINGS: { key: 1, label: "AHORROS" },
  CURRENT: { key: 2, label: "CORRIENTE" },
  SALARY: { key: 3, label: "SUELDO" },
}

const AuditLogAction = {
  CREATE:    { key: "CREATE",    label: "Creación",      color: "badge-gray" },
  UPDATE:    { key: "UPDATE",    label: "Actualización", color: "badge-yellow" },
  DELETE:    { key: "DELETE",    label: "Eliminación",   color: "badge-red" },
  LOGIN:     { key: "LOGIN",     label: "Ingreso",       color: "badge-green" },
  APPROVE:   { key: "APPROVE",   label: "Aprobación",    color: "badge-success" },
  REJECT:    { key: "REJECT",    label: "Rechazo",       color: "badge-danger" },
  CANCEL:    { key: "CANCEL",    label: "Cancelación",   color: "badge-warning" },
  CALCULATE: { key: "CALCULATE", label: "Cálculo",       color: "badge-info" },
  GENERATE:  { key: "GENERATE",  label: "Generación",    color: "badge-info" },
  FINALIZE:  { key: "FINALIZE",  label: "Finalización",  color: "badge-secondary" },
  EXPORT:    { key: "EXPORT",    label: "Exportación",   color: "badge-light" },
}

const AuditLogSection = {
  EMPLOYEE:      { key: "EMPLOYEE",      label: "Colaboradores" },
  CONTRACT:      { key: "CONTRACT",      label: "Contratos" },
  COMPANY:       { key: "COMPANY",       label: "Empresas" },
  AREA:          { key: "AREA",          label: "Áreas" },
  POSITION:      { key: "POSITION",      label: "Cargos" },
  VACATION:      { key: "VACATION",      label: "Vacaciones" },
  MEDICAL_LEAVE: { key: "MEDICAL_LEAVE", label: "Descansos médicos" },
  ATTENDANCE:    { key: "ATTENDANCE",    label: "Asistencia" },
  PAYROLL:       { key: "PAYROLL",       label: "Planillas" },
  MOVEMENT:      { key: "MOVEMENT",      label: "Movimientos" },
  DOCUMENT_TYPE: { key: "DOCUMENT_TYPE", label: "Tipos de documento" },
  MAINTENANCE:   { key: "MAINTENANCE",   label: "Mantenedores" },
}

const MaritalStatus = {
  SOLTERO:     { key: 'SOLTERO',     label: 'SOLTERO' },
  CASADO:      { key: 'CASADO',      label: 'CASADO' },
  DIVORCIADO:  { key: 'DIVORCIADO',  label: 'DIVORCIADO' },
  VIUDO:       { key: 'VIUDO',       label: 'VIUDO' },
  CONVIVIENTE: { key: 'CONVIVIENTE', label: 'CONVIVIENTE' },
}

const BloodType = {
  A_POS:  { key: 'A+',  label: 'A+' },
  A_NEG:  { key: 'A-',  label: 'A-' },
  B_POS:  { key: 'B+',  label: 'B+' },
  B_NEG:  { key: 'B-',  label: 'B-' },
  AB_POS: { key: 'AB+', label: 'AB+' },
  AB_NEG: { key: 'AB-', label: 'AB-' },
  O_POS:  { key: 'O+',  label: 'O+' },
  O_NEG:  { key: 'O-',  label: 'O-' },
}

const DisabilityType = {
  FISICA:      { key: 'FISICA',      label: 'FÍSICA' },
  SENSORIAL:   { key: 'SENSORIAL',   label: 'SENSORIAL' },
  MENTAL:      { key: 'MENTAL',      label: 'MENTAL' },
  INTELECTUAL: { key: 'INTELECTUAL', label: 'INTELECTUAL' },
}

const LaborRegime = {
  GENERAL:      { key: 'GENERAL',      label: 'GENERAL' },
  MYPE_PEQUENA: { key: 'MYPE_PEQUENA', label: 'MYPE PEQUEÑA' },
  MYPE_MICRO:   { key: 'MYPE_MICRO',   label: 'MYPE MICRO' },
  AGRARIO:      { key: 'AGRARIO',      label: 'AGRARIO' },
  CONSTRUCCION: { key: 'CONSTRUCCION', label: 'CONSTRUCCIÓN' },
  HOGAR:        { key: 'HOGAR',        label: 'HOGAR' },
}

const OccupationalCategory = {
  C01: { key: '01', label: 'Ejecutivo / Director' },
  C02: { key: '02', label: 'Empleado' },
  C03: { key: '03', label: 'Obrero' },
  C04: { key: '04', label: 'Trabajador del hogar' },
  C05: { key: '05', label: 'Trabajador de confianza' },
  C06: { key: '06', label: 'Trabajador de dirección' },
}

const WorkerType = {
  W01: { key: '01', label: 'Ejecutivo / Personal de dirección' },
  W02: { key: '02', label: 'Empleado' },
  W03: { key: '03', label: 'Obrero' },
  W04: { key: '04', label: 'Trabajador del hogar' },
  W05: { key: '05', label: 'Trabajador de construcción civil' },
  W06: { key: '06', label: 'Trabajador agrario' },
  W07: { key: '07', label: 'Artista' },
  W99: { key: '99', label: 'Otros' },
}

const SpecialSituation = {
  SINDICALIZADO:  { key: 'SINDICALIZADO',  label: 'SINDICALIZADO' },
  MADRE_GESTANTE: { key: 'MADRE_GESTANTE', label: 'MADRE GESTANTE' },
  NINGUNA:        { key: 'NINGUNA',        label: 'NINGUNA' },
}

const EducationLevel = {
  SECUNDARIA:    { key: 'SECUNDARIA',    label: 'SECUNDARIA' },
  TECNICO:       { key: 'TECNICO',       label: 'TÉCNICO' },
  UNIVERSITARIO: { key: 'UNIVERSITARIO', label: 'UNIVERSITARIO' },
  MAESTRIA:      { key: 'MAESTRIA',      label: 'MAESTRÍA' },
  DOCTORADO:     { key: 'DOCTORADO',     label: 'DOCTORADO' },
}

const PensionSystem = {
  AFP:         { key: 'AFP',         label: 'AFP' },
  ONP:         { key: 'ONP',         label: 'ONP' },
  SIN_REGIMEN: { key: 'SIN_REGIMEN', label: 'SIN RÉGIMEN' },
}

const AfpCommissionType = {
  FLUJO: { key: 'FLUJO', label: 'FLUJO' },
  MIXTA: { key: 'MIXTA', label: 'MIXTA' },
}

const FifthCategoryStatus = {
  AFECTO:    { key: 'AFECTO',    label: 'AFECTO' },
  EXONERADO: { key: 'EXONERADO', label: 'EXONERADO' },
}

const EmergencyRelationship = {
  MADRE:   { key: 'MADRE',   label: 'MADRE' },
  PADRE:   { key: 'PADRE',   label: 'PADRE' },
  CONYUGE: { key: 'CONYUGE', label: 'CÓNYUGE' },
  HERMANO: { key: 'HERMANO', label: 'HERMANO/A' },
  OTRO:    { key: 'OTRO',    label: 'OTRO' },
}

const SalaryCurrency = {
  PEN: { key: 'PEN', label: 'PEN - Soles' },
  USD: { key: 'USD', label: 'USD - Dólares' },
}

const WorkSchedule = {
  COMPLETA: { key: 'COMPLETA', label: 'COMPLETA' },
  PARCIAL:  { key: 'PARCIAL',  label: 'PARCIAL' },
  NOCTURNA: { key: 'NOCTURNA', label: 'NOCTURNA' },
}

const VacationRequestStatus = {
  PENDIENTE: { key: 'PENDIENTE', label: 'PENDIENTE',  color: 'badge-yellow' },
  APROBADA:  { key: 'APROBADA',  label: 'APROBADA',   color: 'badge-green'  },
  RECHAZADA: { key: 'RECHAZADA', label: 'RECHAZADA',  color: 'badge-danger' },
  CANCELADA: { key: 'CANCELADA', label: 'CANCELADA',  color: 'badge-gray'   },
}

const VacationPeriodStatus = {
  VIGENTE:    { key: 'VIGENTE',    label: 'VIGENTE',    color: 'badge-green'  },
  POR_VENCER: { key: 'POR_VENCER', label: 'POR VENCER', color: 'badge-yellow' },
  VENCIDO:    { key: 'VENCIDO',    label: 'VENCIDO',    color: 'badge-danger' },
  GOZADO:     { key: 'GOZADO',     label: 'GOZADO',     color: 'badge-info'   },
}

const WorkSiteStatus = {
  ACTIVE:   { key: 1, label: 'ACTIVO',     color: 'badge-green',  action: 'Suspender' },
  INACTIVE: { key: 0, label: 'SUSPENDIDO', color: 'badge-yellow', action: 'Activar'   },
}

const DocumentTypeStatus = {
  ACTIVE:   { key: 1, label: 'ACTIVO',     color: 'badge-green',  action: 'Suspender' },
  INACTIVE: { key: 0, label: 'SUSPENDIDO', color: 'badge-yellow', action: 'Activar'   },
}

const MedicalLeaveType = {
  ENFERMEDAD: { key: 'ENFERMEDAD', label: 'Enfermedad', color: 'badge-warning' },
  ACCIDENTE:  { key: 'ACCIDENTE',  label: 'Accidente',  color: 'badge-danger'  },
  MATERNIDAD: { key: 'MATERNIDAD', label: 'Maternidad', color: 'badge-info'    },
  PATERNIDAD: { key: 'PATERNIDAD', label: 'Paternidad', color: 'badge-blue'    },
}

const MedicalLeaveStatus = {
  ACTIVO:     { key: 'ACTIVO',     label: 'ACTIVO',     color: 'badge-green' },
  FINALIZADO: { key: 'FINALIZADO', label: 'FINALIZADO', color: 'badge-blue'  },
  CANCELADO:  { key: 'CANCELADO',  label: 'CANCELADO',  color: 'badge-gray'  },
}

const MedicalLeaveCaseStatus = {
  DESCANSO_MEDICO: { key: 'DESCANSO_MEDICO', label: 'Descanso médico', color: 'badge-secondary' },
  SUBSIDIO:        { key: 'SUBSIDIO',        label: 'Subsidio EsSalud', color: 'badge-warning'  },
}

const MedicalLeaveProcessStatus = {
  PENDIENTE:  { key: 'PENDIENTE',  label: 'Pendiente',  color: 'badge-danger'  },
  EN_TRAMITE: { key: 'EN_TRAMITE', label: 'En trámite', color: 'badge-warning' },
  COBRADO:    { key: 'COBRADO',    label: 'Cobrado',    color: 'badge-success' },
}

const MedicalLeaveInsuranceType = {
  PARTICULAR: { key: 'PARTICULAR', label: 'Particular' },
  ESSALUD:    { key: 'ESSALUD',    label: 'EsSalud'    },
}

const PensionEntityType = {
  AFP: { key: 'AFP', label: 'AFP' },
  ONP: { key: 'ONP', label: 'ONP' },
}

const PensionEntityStatus = {
  ACTIVE:   { key: 1, label: 'ACTIVO',     color: 'badge-green',  action: 'Suspender' },
  INACTIVE: { key: 0, label: 'SUSPENDIDO', color: 'badge-yellow', action: 'Activar'   },
}

const BankStatus = {
  ACTIVE:   { key: 1, label: 'ACTIVO',     color: 'badge-green',  action: 'Suspender' },
  INACTIVE: { key: 0, label: 'SUSPENDIDO', color: 'badge-yellow', action: 'Activar'   },
}

const PayrollConceptType = {
  DESCUENTO: { key: 'DESCUENTO', label: 'Descuento' },
  ADICIONAL:  { key: 'ADICIONAL',  label: 'Adicional'  },
}

const PayrollConceptNature = {
  REMUNERATIVO:    { key: 'REMUNERATIVO',    label: 'Remunerativo'    },
  NO_REMUNERATIVO: { key: 'NO_REMUNERATIVO', label: 'No remunerativo' },
  NA:              { key: 'NA',              label: 'N/A'             },
}

const PayrollConceptStatus = {
  ACTIVE:   { key: 1, label: 'ACTIVO',     color: 'badge-green',  action: 'Suspender' },
  INACTIVE: { key: 0, label: 'SUSPENDIDO', color: 'badge-yellow', action: 'Activar'   },
}

const PayrollMovementStatus = {
  PENDIENTE: { key: 'PENDIENTE', label: 'PENDIENTE', color: 'badge-yellow' },
  PROCESADO: { key: 'PROCESADO', label: 'PROCESADO', color: 'badge-green'  },
  CANCELADO: { key: 'CANCELADO', label: 'CANCELADO', color: 'badge-gray'   },
}

const PayrollMovementOrigin = {
  MANUAL:     { key: 'MANUAL',     label: 'Manual'    },
  ASISTENCIA: { key: 'ASISTENCIA', label: 'Asistencia' },
  PRESTAMO:   { key: 'PRESTAMO',   label: 'Préstamo'  },
  CUOTA:      { key: 'CUOTA',      label: 'Cuota'     },
}


const VoucherType = {
  RECIBO:       { key: 'RECIBO',       label: 'Recibo'          },
  FACTURA:      { key: 'FACTURA',      label: 'Factura'         },
  BOLETA:       { key: 'BOLETA',       label: 'Boleta'          },
  NOTA_CREDITO: { key: 'NOTA_CREDITO', label: 'Nota de crédito' },
  OTRO:         { key: 'OTRO',         label: 'Otro'            },
}

const InstallmentGroupStatus = {
  EN_CURSO:   { key: 'EN_CURSO',   label: 'En curso',   color: 'badge-yellow' },
  COMPLETADO: { key: 'COMPLETADO', label: 'Completado', color: 'badge-green'  },
  CANCELADO:  { key: 'CANCELADO',  label: 'Cancelado',  color: 'badge-gray'   },
}

const AttendanceStatus = {
  ASISTIO:             { key: 'ASISTIO',             label: 'Asistió',             color: '#28a745', letter: 'A'  },
  FALTA_JUSTIFICADA:   { key: 'FALTA_JUSTIFICADA',   label: 'Falta justificada',   color: '#17a2b8', letter: 'FJ' },
  FALTA_INJUSTIFICADA: { key: 'FALTA_INJUSTIFICADA', label: 'Falta injustificada', color: '#dc3545', letter: 'F'  },
  VACACIONES:          { key: 'VACACIONES',          label: 'Vacaciones',          color: '#007bff', letter: 'V'  },
  DESCANSO_MEDICO:     { key: 'DESCANSO_MEDICO',     label: 'Descanso médico',     color: '#fd7e14', letter: 'DM' },
  FERIADO:             { key: 'FERIADO',             label: 'Feriado',             color: '#6f42c1', letter: 'FE' },
  DESCANSO:            { key: 'DESCANSO',            label: 'Descanso',            color: '#adb5bd', letter: 'D'  },
  PERMISO:             { key: 'PERMISO',             label: 'Permiso',             color: '#e83e8c', letter: 'P'  },
}

const RelationshipType = {
  HIJO:        { key: 'HIJO',        label: 'Hijo(a)' },
  CONYUGE:     { key: 'CONYUGE',     label: 'Cónyuge' },
  CONVIVIENTE: { key: 'CONVIVIENTE', label: 'Conviviente' },
}

const FamilyAllowanceStatus = {
  CALIFICA:               { key: 'CALIFICA',               label: 'Califica',               color: 'badge-success' },
  NO_CALIFICA:            { key: 'NO_CALIFICA',            label: 'No califica',            color: 'badge-danger'  },
  CONSTANCIA_POR_VENCER:  { key: 'CONSTANCIA_POR_VENCER',  label: 'Constancia por vencer',  color: 'badge-warning' },
}

const PayrollTypeStatus = {
  ACTIVE:   { key: 1, label: 'ACTIVO',     color: 'badge-green',  action: 'Suspender' },
  INACTIVE: { key: 0, label: 'SUSPENDIDO', color: 'badge-yellow', action: 'Activar'   },
}

const WorkScheduleStatus = {
  ACTIVE:   { key: 1, label: 'ACTIVO',     color: 'badge-green',  action: 'Suspender' },
  INACTIVE: { key: 0, label: 'SUSPENDIDO', color: 'badge-yellow', action: 'Activar'   },
}

const PayrollFrequency = {
  WEEKLY:   { key: 'WEEKLY',   label: 'Semanal'    },
  BIWEEKLY: { key: 'BIWEEKLY', label: 'Quincenal'  },
  MONTHLY:  { key: 'MONTHLY',  label: 'Mensual'    },
}

const PayrollTaxCategory = {
  FIFTH:  { key: 'FIFTH',  label: '5ta categoria' },
  FOURTH: { key: 'FOURTH', label: '4ta categoria' },
}

export default {
  Errors,
  EmployeeStatus,
  IdentifierType,
  BooleanTypes,
  AreaStatus,
  CompanyStatus,
  ContractDurationOptions,
  RolesStatus,
  ContractStatus,
  PayrollTypes,
  AccountType,
  AuditLogAction,
  AuditLogSection,
  MaritalStatus,
  BloodType,
  DisabilityType,
  LaborRegime,
  OccupationalCategory,
  WorkerType,
  SpecialSituation,
  EducationLevel,
  PensionSystem,
  AfpCommissionType,
  FifthCategoryStatus,
  EmergencyRelationship,
  SalaryCurrency,
  WorkSchedule,
  TerminationReason,
  VacationRequestStatus,
  VacationPeriodStatus,
  PensionEntityType,
  PensionEntityStatus,
  WorkSiteStatus,
  DocumentTypeStatus,
  MedicalLeaveType,
  BankStatus,
  PayrollConceptType,
  PayrollConceptNature,
  PayrollConceptStatus,
  PayrollMovementStatus,
  PayrollMovementOrigin,
  AttendanceStatus,
  MedicalLeaveStatus,
  MedicalLeaveCaseStatus,
  MedicalLeaveProcessStatus,
  MedicalLeaveInsuranceType,
  VoucherType,
  InstallmentGroupStatus,
  RelationshipType,
  FamilyAllowanceStatus,
  ChannelStatus: {
    ACTIVE:   { key: 1, label: 'ACTIVO',     color: 'badge-green',  action: 'Suspender' },
    INACTIVE: { key: 0, label: 'SUSPENDIDO', color: 'badge-yellow', action: 'Activar'   },
  },
  ExpenseLineStatus: {
    ACTIVE:   { key: 1, label: 'ACTIVO',     color: 'badge-green',  action: 'Suspender' },
    INACTIVE: { key: 0, label: 'SUSPENDIDO', color: 'badge-yellow', action: 'Activar'   },
  },
  PayrollTypeStatus,
  PayrollFrequency,
  PayrollTaxCategory,
  WorkScheduleStatus,
};
